import { render, staticRenderFns } from "./InternalCatalogs.vue?vue&type=template&id=007648ca&"
import script from "./InternalCatalogs.vue?vue&type=script&lang=js&"
export * from "./InternalCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports